var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserSpeakingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.777,
    height: 28.024,
    viewBox: "0 0 33.777 28.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#666;stroke:#666;stroke-width:0.4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.28 -8.404)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.121,35a.482.482,0,0,1-.475-.4,11.139,11.139,0,0,1-.166-1.549.483.483,0,0,1,.965-.036A10.24,10.24,0,0,0,3.6,34.427a.482.482,0,0,1-.391.558.468.468,0,0,1-.085.01Z",
    transform: "translate(0 -12.312)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.826,36.007H9.621a.482.482,0,0,1-.482-.482v-.511a13.464,13.464,0,0,0-2.715-7.955c-.18-.246-.355-.506-.516-.772a.484.484,0,0,1,.828-.5c.145.241.3.479.468.7a14.421,14.421,0,0,1,2.9,8.525v.029h11.24V33.276a1.989,1.989,0,0,1,1.988-1.988h1.312a1.63,1.63,0,0,0,1.626-1.631V26.61a.482.482,0,0,1,.386-.473l1.756-.358L26.3,20.448a.476.476,0,0,1-.034-.178A10.54,10.54,0,0,0,7.821,13.291a.483.483,0,1,1-.724-.639,11.508,11.508,0,0,1,20.135,7.526l2.288,5.781a.482.482,0,0,1-.352.65L27.235,27v2.653a2.6,2.6,0,0,1-2.59,2.6H23.331a1.024,1.024,0,0,0-1.023,1.023v2.248a.482.482,0,0,1-.482.484Z",
    transform: "translate(-1.738 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.765,25.051a.469.469,0,0,1-.126-.017.482.482,0,0,1-.338-.591,10.732,10.732,0,0,1,.495-1.42.482.482,0,1,1,.887.38,9.89,9.89,0,0,0-.453,1.291A.482.482,0,0,1,3.765,25.051Z",
    transform: "translate(-0.416 -7.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M61.711,50.481a.482.482,0,0,1-.276-.878,9.021,9.021,0,0,0,2.229-12.547.483.483,0,0,1,.792-.552A9.989,9.989,0,0,1,61.987,50.4.48.48,0,0,1,61.711,50.481Z",
    transform: "translate(-30.407 -14.252)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M58.492,49.925a.482.482,0,0,1-.276-.878,6.307,6.307,0,0,0,1.558-8.772.483.483,0,1,1,.792-.552,7.273,7.273,0,0,1-1.8,10.115.482.482,0,0,1-.275.087Z",
    transform: "translate(-28.741 -15.919)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M55.272,49.367A.482.482,0,0,1,55,48.489a3.592,3.592,0,0,0,.887-4.994.482.482,0,0,1,.791-.552,4.555,4.555,0,0,1-1.126,6.337A.482.482,0,0,1,55.272,49.367Z",
    transform: "translate(-27.075 -17.585)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSpeakingIcon);
export default __webpack_public_path__ + "static/media/user-speaking-icon.60fc0ce1c9c48e9f0fd78d6aee155407.svg";
export { ForwardRef as ReactComponent };